import { render } from "./massive-exclusion-detail.vue?vue&type=template&id=4629d5b2"
import script from "./massive-exclusion-detail.vue?vue&type=script&lang=js"
export * from "./massive-exclusion-detail.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__